// Company: Ajinsoft
// Author: Uilan Coqueiro
// Date: 2024-02-02

import { ApiConfig } from '@ajin/config/api.config';
import { IdListParams } from '@ajin/entities/id-list.params';
import { UpdateStatusParams } from '@ajin/entities/update-status.params';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserApiService {
	private _url = ApiConfig.url + 'users';
	private _supportUrl = ApiConfig.url + 'user-supports';
	private _httpClient = inject(HttpClient);

	get(id: string): Observable<any> {
		return this._httpClient.get(`${this._url}/${id}`);
	}

	create(params: any): Observable<any> {
		return this._httpClient.post(this._url, params);
	}

	update(id: string, params: any): Observable<any> {
		return this._httpClient.put(`${this._url}/${id}`, params);
	}

	updateStatus(id: string, params: UpdateStatusParams): Observable<any> {
		return this._httpClient.put(`${this._url}/${id}/status`, params);
	}

	updateAccessId(id: string, params: any): Observable<any> {
		return this._httpClient.put(`${this._url}/${id}/access-id`, params);
	}

	updatePassword(id: string, params: any): Observable<any> {
		return this._httpClient.put(`${this._url}/${id}/password`, params);
	}

	restore(params: IdListParams): Observable<any> {
		return this._httpClient.post(`${this._url}/restore`, params);
	}

	list(filter: any): Observable<any> {
		return this._httpClient.post(`${this._url}/list`, filter);
	}

	search(filter: any): Observable<any> {
		return this._httpClient.post(`${this._url}/search`, filter);
	}

	support(): Observable<any> {
		return this._httpClient.get(this._supportUrl);
	}

	createBroker(id: string, params: any): Observable<any> {
		return this._httpClient.post(`${this._url}/${id}/brokers`, params);
	}

	createAuthKey(id: string): Observable<any> {
		return this._httpClient.put(`${this._url}/${id}/auth-key`, null);
	}

	removeAuthKey(id: string): Observable<any> {
		return this._httpClient.delete(`${this._url}/${id}/auth-key`);
	}

	export(params: any): Observable<any> {
		return this._httpClient.post(`${this._url}/exports`, params);
	}

	updatePartnerGroup(id: string, params: any): Observable<any> {
		return this._httpClient.put(`${this._url}/${id}/groups`, params);
	}

	activate(id: string): Observable<any> {
		return this._httpClient.put(`${this._url}/${id}/activation`, null);
	}

	deactivate(id: string): Observable<any> {
		return this._httpClient.put(`${this._url}/${id}/deactivation`, null);
	}

	getPasswordStatus(headers?: any): Observable<any> {
		return this._httpClient.get(`${this._url}/password/status`, { headers });
	}
}
